import React, { useContext, useEffect, useState } from 'react'
import { useGet } from 'restful-react'
import { QuotationIndex, ApiError } from 'EstraSuppliers'
import { endpoints } from 'app/api/endpoints'
import { Title } from 'app/components/ui/Title'
import { Text } from 'app/components/ui/Text'
import { Image } from 'app/components/ui/Image'
import styled from 'styled-components'
import { themeEstra } from 'app/styles/themeEstra'
import { Base } from 'app/components/ui/Base'
import { Container } from 'app/components/ui/Container'
import { QuotationsTable } from 'app/components/shared/QuotationsTable'
import { HeaderContext } from 'app/Contexts/HeaderProvider'
import { LoadingSpinner } from 'app/components/ui/LoadingSpinner'
import { BlobCardHomeList } from 'app/components/shared/BlobCardHomeList'
import { Card } from 'app/components/ui/Card'
import { CardPerson } from 'app/components/shared/CardPerson'
import { OfferModal } from './OfferModal'

export const QuotationList: React.FC = () => {
  const headerCtx = useContext(HeaderContext)

  const headerTitle = 'Area fornitori Marketing'
  const headerSubTitle =
    'Benvenuto nella tua area dedicata! Qui trovi tutte le richieste di preventivo \n inviate a te dal Servizio Marketing e Comunicazione del gruppo Estra.'

  useEffect(() => {
    if (headerCtx) {
      if (headerCtx) headerCtx.updateTitles(headerTitle, headerSubTitle)
      headerCtx.updateSubtitleVariant('quotations')
    }
  }, [])

  const [showOfferModal, setShowOfferModal] = useState(false)

  // API FETCH
  const { data: quotations, loading } = useGet<QuotationIndex, ApiError>({
    path: endpoints.quotationsIndex,
  })

  if (loading) {
    return <LoadingSpinner></LoadingSpinner>
  }

  return (
    <>
      <Container>
        <TitleWrapper forwardedAs='Container'>
          <Title size={3}>I tuoi preventivi</Title>
          {quotations?.length ? (
            <Text variant='s20'>
              Clicca sull’oggetto del preventivo per vederne il dettaglio
            </Text>
          ) : null}
        </TitleWrapper>
      </Container>
      <Base
        bgImage='https://res.cloudinary.com/estra/image/upload/v1611841825/estra20dev/area_fornitori/quotations/quotations_bg.svg'
        paddingTop={8}
      >
        <QuotationsContainer>
          {quotations?.length ? (
            <QuotationsTable allQuotations={quotations}></QuotationsTable>
          ) : (
            <NoQuotationsWrapper>
              <img
                src='https://res.cloudinary.com/estra/image/upload/v1611838287/estra20dev/area_fornitori/quotations/no_quotations.svg'
                alt='no_quotations'
              ></img>
              <Title size={4} color={themeEstra.color.primari.grigioEstra}>
                Non hai ancora preventivi da visionare.
              </Title>
            </NoQuotationsWrapper>
          )}
        </QuotationsContainer>
      </Base>
      <OfferContainer>
        <BlobCardHomeList>
          <OfferImageWrapper>
            <div>
              <Image
                onClick={() => setShowOfferModal(true)}
                fluid
                src='https://res.cloudinary.com/estra/image/upload/v1614766951/estra20dev/area_fornitori/promo/promo_lg_supplier_green_offer.png'
              ></Image>
            </div>
          </OfferImageWrapper>
          <Card shadow padding='4rem' mobilePadding='2rem' variant='deckPurple'>
            <Title size={5}>FORNITORE DI VALORE</Title>
            <Text
              variant='s20'
              color={themeEstra.color.primari.grigioEstra}
              mb={2}
              mt={2}
            >
              Qui in Estra teniamo molto ai nostri valori e li condividiamo con
              i nostri fornitori.{'\n'}
              <a
                href='https://www.estra.it/noi'
                target='_blank'
                rel='noopener noreferrer'
              >
                Leggi il nostro manifesto
              </a>
            </Text>
            <Text variant='s20' color={themeEstra.color.primari.grigioEstra}>
              Siamo una risorsa per i territori nei quali operiamo, occupando
              centinaia di aziende e attività.{'\n'}
              <a
                href='https://bilanciodisostenibilita.estra.it/'
                target='_blank'
                rel='noopener noreferrer'
              >
                Leggi il Bilancio di Sostenibilità
              </a>
            </Text>
          </Card>
          <CardPersonWrapper>
            <CardPerson
              avatarUrl='https://res.cloudinary.com/estra/image/upload/v1614765573/estra20dev/area_fornitori/authors/baldini.jpg'
              tagline='Scopri il nostro impegno GREEN con'
              personName='SARA BALDINI'
              role='Pricing e programmazione'
              link='https://www.estra.it/' // TODO Change
              openInNewTab
            ></CardPerson>
          </CardPersonWrapper>
        </BlobCardHomeList>
      </OfferContainer>
      <OfferModal isVisible={showOfferModal} onToggle={setShowOfferModal} />
    </>
  )
}

const QuotationsContainer = styled(Container)`
  min-height: 400px;
`

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  //Add margin to children
  > * {
    margin-bottom: 2rem;
  }
`

const TitleWrapper = styled(Wrapper)``

const NoQuotationsWrapper = Wrapper

const OfferContainer = styled(Container)`
  display: none; //TODO: Reimplement
`

const OfferImageWrapper = styled.div`
  display: flex;
  justify-content: center;

  margin-top: -7rem;

  @media (max-width: ${themeEstra.bp.tablet}) {
    margin-top: 0;
  }
`

const CardPersonWrapper = styled.div`
  display: flex;
  justify-content: center;

  margin-top: -3rem;

  @media (max-width: ${themeEstra.bp.tablet}) {
    margin-top: 0;
  }
`
